import { DEFAULT_LANG } from 'common/constants'
import { GetServerSideProps } from 'next'
import ContactUs from 'services/Home/screens/Home/ContactUs'

export const getServerSideProps: GetServerSideProps = async ({
  req,
}) => {
  const lang = req.cookies.lang || DEFAULT_LANG
  return {
    props: {
      pageName: 'Hubungi Kami',
      lang,
    },
  }
}

export default ContactUs
